import { lazy } from 'react'
import { Calendar, Folder, HelpCircle, ShieldCheck, Users } from 'lucide-react'
import type { FeatureRoute, NavItem } from '@/features/types'

// Cross-cutting "workspace" pages that don't belong to a single domain.
const Resources = lazy(() => import('@/features/workspace/pages/Resources').then((m) => ({ default: m.Resources })))
const Vendors = lazy(() => import('@/features/workspace/pages/Vendors').then((m) => ({ default: m.Vendors })))
const Iterations = lazy(() => import('@/features/workspace/pages/Iterations').then((m) => ({ default: m.Iterations })))
const Profile = lazy(() => import('@/features/workspace/pages/Profile').then((m) => ({ default: m.Profile })))
const Team = lazy(() => import('@/features/workspace/pages/Team').then((m) => ({ default: m.Team })))
const Help = lazy(() => import('@/features/workspace/pages/Help').then((m) => ({ default: m.Help })))

export const workspaceRoutes: FeatureRoute[] = [
  { path: 'resources', element: <Resources /> },
  { path: 'vendors', element: <Vendors /> },
  { path: 'iterations', element: <Iterations /> },
  { path: 'profile', element: <Profile /> },
  { path: 'team', element: <Team /> },
  { path: 'help', element: <Help /> },
]

export const workspaceNav: NavItem[] = [
  { to: '/iterations', label: 'Iterations', icon: Calendar, section: 'Sales' },
  { to: '/team', label: 'Team', icon: Users, section: 'Tools' },
  { to: '/resources', label: 'Resources', icon: Folder, section: 'Tools' },
  { to: '/vendors', label: 'Vendor panel', icon: ShieldCheck, section: 'Tools' },
  { to: '/help', label: 'Help', icon: HelpCircle, section: 'Tools' },
]
